import { render, staticRenderFns } from "./reg.vue?vue&type=template&id=464a07de&scoped=true&"
import script from "./reg.vue?vue&type=script&lang=ts&"
export * from "./reg.vue?vue&type=script&lang=ts&"
import style0 from "./reg.vue?vue&type=style&index=0&id=464a07de&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464a07de",
  null
  
)

export default component.exports